import * as React from 'react'
import clsx from 'clsx'
import { defaultFormatPrice } from './ProductQtyInput'

export type PriceOption = {
  originalPrice: number
  discount: number
  finalPrice: number
  quantity: number
  maxQuantity?: number
}

interface ProductQtyRowProps {
  opt: PriceOption
  onClick?: () => void
  rightSlot?: React.ReactNode
  classes?: {
    container?: string
    discountContainer?: string
  }
  showBadge?: boolean
  showBorder?: boolean
  showShadow?: boolean
  compact?: boolean
}

const ProductQtyRow: React.FC<ProductQtyRowProps> = ({
  opt,
  onClick,
  rightSlot,
  classes,
  showBadge = false,
  showBorder = false,
  showShadow = false,
  compact = false,
}) => {
  return (
    <div
      className={clsx(
        'relative w-full bg-white',
        showBorder &&
          (compact
            ? 'border border-solid border-[#E6E8EB] rounded-md p-1 my-1'
            : 'border border-solid border-[#E6E8EB] rounded-md p-2 my-2 '),
        showShadow && 'shadow-sm',
        classes?.container
      )}
      style={{
        width: showBorder ? (compact ? 'calc(100% + 8px)' : 'calc(100% + 16px)') : '100%',
      }}
    >
      <div
        onClick={onClick}
        className={clsx(['flex justify-between items-center w-full', onClick && 'cursor-pointer'])}
      >
        <div
          className={clsx(
            'text-center text-[#949696] line-through !font-thin whitespace-nowrap',
            compact ? 'w-12 text-[10px]' : 'w-16'
          )}
          title="Prix HT avant remise"
        >
          {defaultFormatPrice(opt?.originalPrice)}
        </div>

        <div className="text-center">
          <div
            className={clsx(
              'text-[#FFAC0A] rounded-md font-bold whitespace-nowrap',
              compact ? 'px-1 py-0.5 w-10 text-[10px]' : 'p-2 w-12',
              classes?.discountContainer
            )}
          >
            {opt.discount > 0 ? `-${Math.round(opt.discount)}%` : '—'}
          </div>
        </div>

        <div
          className={clsx(
            'text-center !text-[#4453A1] font-bold whitespace-nowrap',
            compact && 'text-xs'
          )}
        >
          {defaultFormatPrice(opt.finalPrice)}
        </div>

        <div className={clsx('text-center', compact ? 'w-16' : 'w-24')}>{rightSlot}</div>
      </div>

      {showBadge && (
        <div
          className={clsx(
            'text-white font-bold absolute bg-[linear-gradient(90deg,#4453A1_0%,#9DB1DD_100%)] rounded-lg',
            compact ? '-top-2 left-0.5 text-[9px] px-1 py-0.5' : '-top-3 left-1 text-xs py-1 p-2'
          )}
        >
          Meilleur prix
        </div>
      )}
    </div>
  )
}

export default ProductQtyRow
